import {Component, input, signal} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {AccordionConfig} from '@core/types';

@Component({
  selector: 'core-accordion',
  imports: [
    NgTemplateOutlet,
  ],
  templateUrl: './accordion.html',
  styleUrl: './accordion.scss',
  standalone: true
})
export class Accordion {

  config = input<AccordionConfig[]>();
  openedPanels = signal<string[]>([]);

  togglePanel(slug: string | undefined) {
    if (!slug) return;

    this.openedPanels.update(current =>
      current.includes(slug)
        ? current.filter(s => s !== slug)
        : [...current, slug]
    );
  }

  isOpen(slug: string | undefined): boolean {
    return !!slug && this.openedPanels().includes(slug);
  }

}
